"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");



























































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数 注意vue页面中import的函数需要在methods注册才可生效
var _default = { data: function data() {return { tableData: [], // 列表数据
      appList: [], versionList: [], title: '', newadd: false, addData: { id: '', appId: '', appVersion: '', otaVersionId: '', terminalType: '', type: 1 }, defaultData: { id: '', appId: '', appVersion: '', otaVersionId: '', terminalType: '', type: 1 }, searchData: { appId: '', appVersion: '', terminalType: '', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'appName', label: 'app名称', isShow: true }, { prop: 'terminalType', label: '终端', formatter: _formatter.terminalTypeFormatter, isShow: true }, { prop: 'appVersion', label: '兼容app版本', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], rules: { appId: [{ required: true, message: '请选择APP名称', trigger: 'blur' }], terminalType: [{ required: true, message: '请选择终端', trigger: 'blur' }], appVersion: [{ required: true, message: '请选择兼容app版本', trigger: 'change' }] } };}, mounted: function mounted() {var self = this;self.addData.otaVersionId = self.$route.params.parentId;self.defaultData.otaVersionId = self.$route.params.parentId;self.init();self.getAppList();},
  methods: {
    init: function init() {
      var self = this;
      var params = Object.assign({}, self.searchData);
      params.otaVersionId = self.addData.otaVersionId;
      // console.log('params======>',params)
      self.getData('/api/faOtaVersionLimit', params, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    handleSizeChange: function handleSizeChange(val) {
      // 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      // 分页页码
      this.searchData.page = val;
      this.init();
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.
      $confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).

      then(function () {
        self.delData('/api/faOtaVersionLimit/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).
      catch(function () {});
    },
    addFun: function addFun() {
      // 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      console.log(item);
      self.changeAppFun(item.appId);
      self.addData = {
        id: item.id,
        appId: item.appId,
        otaVersionId: item.otaVersionId,
        terminalType: item.terminalType + '',
        appVersion: item.appVersion,
        type: 1 };

      self.newadd = true;
    },
    onSubmit: function onSubmit(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionLimit', self.addData, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionUpdateContent/', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    dropList: function dropList() {
      var self = this;
      self.getData('/api/faDeviceType', {}, function (res) {
        self.deviceTypelist = res.list;
      });
    },
    getAppList: function getAppList() {
      var self = this;
      self.getData('/api/appVersion/apps', {}, function (res) {
        self.appList = res;
      });
    },
    changeAppFun: function changeAppFun(data) {
      var self = this;
      var obj = {};
      obj = self.appList.find(function (item) {
        return item.appId === data;
      });
      self.addData.appId = obj.appId;
      self.addData.appVersion = '';
      self.getData(
      '/api/appVersion/versions',
      {
        appId: self.addData.appId,
        terminalType: self.addData.terminalType },

      function (res) {
        self.versionList = res;
      });

    },
    changeTypeFun: function changeTypeFun(val) {
      var self = this;
      self.addData.terminalType = '';
      if (val === '1') {
        self.addData.terminalType = '1';
      } else if (val === '2') {
        self.addData.terminalType = '2';
      } else if (val === '3') {
        self.addData.terminalType = '3';
      } else if (val === '4') {
        self.addData.terminalType = '4';
      }
      self.addData.appVersion = '';
      self.getData(
      '/api/appVersion/versions',
      {
        appId: self.addData.appId,
        terminalType: self.addData.terminalType },

      function (res) {
        self.versionList = res;
      });

    },
    onCencal: function onCencal() {
      this.$refs.addForm.resetFields();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.$refs['addForm'].resetFields();
      this.newadd = false;
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/core/coreEdition');
    },
    resetFun: function resetFun() {
      // 重置
      this.searchData.appId = '';
      this.searchData.appVersion = '';
      this.searchData.terminalType = '';
      this.init();
    },
    searchFun: function searchFun() {
      // 搜索事件
      this.searchData.page = 1;
      this.init();
    } } };exports.default = _default;